/* eslint-disable max-len */
export default {
  ACTIONS: {
    BACK: 'Indietro',
    CANCEL: 'Cancella',
    CLOSE: 'Chiudi',
    COLLECT: 'Ritira',
    CONFIRM: 'Conferma',
    NEW_USER: 'Nuovo utente',
    NEXT: 'Prossimo',
    SAVE: 'Salva',
    SCAN_QR_CODE: 'Scansiona il codice QR',
    SWIPE_DOWN: 'Scorri verso il basso per nascondere i dettagli',
    SWIPE_UP: 'Scorri veso l\'alto per vedere i dettagli',
    WITHOUT_PIN: 'Non hai un PIN o un codice QR? {link}',
    WITHOUT_PIN_TO_COLLECT: 'Non hai un PIN? {link}'
  },
  ERRORS: {
    INVALID_CODE: 'Codice non valido.',
    INVALID_EMAIL: 'E-mail non valida.',
    INVALID_NUMBER: 'Numero non valido.',
    INVALID_PHONE: 'Telefono non valido.',
    INVALID_USER: 'Utente non valido.',
    ORDER_DELIVER_INVALID_CODE: '{code} non valido.',
    ORDER_DELIVERED: 'L\'ordine è stato consegnato.',
    SOMETHING_WENT_WRONG: 'C\'è stato un errore!',
    UNABLE_TO_VALIDATE: 'Non è stato possibile convalidare l\'ordine.',
    VALIDATING_CODE: 'Non è stato possibile convalidare il codice {code}.'
  },
  LABELS: {
    ACCEPT_RETURN: 'Sei sicuro di voler accettare il reso?',
    ALL_ORDERS: 'Vedi tutti',
    ANOMALY: 'Anomalia?',
    CANCELED: 'Cancellato',
    CLICK_HERE: 'Clicca qui',
    CLIENT_NAME: 'Cliente',
    COLLECT_ORDER: 'Restituire l\'ordine',
    COLLECTS_NOT_FOUND: 'Non sono stati trovati ritiri.',
    CUSTOMER_SIGNATURE: 'Firma del cliente',
    DATE_AND_HOUR: 'Data e ora',
    DELIVER_ORDER: 'Consegna ordine',
    DELIVERED: 'Consegnato',
    EMAIL: 'E-mail',
    ERROR: 'Errore',
    IDENTITY_DOCUMENT: 'Documento d\'identità',
    IDENTITY_NAME: 'Nome sul documento d\'identità',
    IDENTITY_NUMBER: 'Numero del documento d\'identità',
    NAME: 'Nome',
    NEW_USER: 'Nuovo utente',
    NO_USERS: 'Non esiste ancora nessun utente',
    NOT_DELIVERED: 'Non consegnato',
    OR: 'O',
    ORDER_CODE: 'Codice dell\'ordine',
    ORDER_NUMBER: 'Numero dell\'ordine',
    PACKAGE_NUMBER: 'Numero del pacco',
    PACKAGES: 'Pacchi',
    PACKAGES_CODES: 'Codici delle scatole',
    PACKAGES_DELIVERED: 'Pacchi consegnati',
    PACKAGES_NUMBER: 'Numero di pacchi',
    PACKAGES_RECEIVED: 'Pacchi ricevuti',
    PHONE: 'Telefono',
    PHONE_EXAMPLE: ', esempio: +351999999999',
    PICK_UP_COLLECT_PIN: 'PIN di restituzione',
    PICK_UP_NOT_FOUND: 'Non è stato incontrato nessun punto di ritiro',
    PICK_UP_PIN: 'PIN per il ritiro',
    PICK_UP_SEARCH: 'Trova un punto di ritiro',
    PICK_UP_SELECT: 'Seleziona un punto di ritiro',
    PROCESSING: 'In elaborazione',
    READ_CLIENT_DELIVERY_QR_CODE: 'Leggi il codice QR di ritiro',
    READ_PACKAGE_QR_CODE: 'Leggi il codice QR del pacco',
    RECEIVE_PACKAGES: 'Ricevi pacchi',
    RECEIVED_BY: 'Ricevuto da',
    RETURNED: 'Restituito',
    RETURNS: 'Restituzioni',
    SEARCH_FOR: 'Cerca',
    SELECT_DELIVER: 'Seleziona un ordine da consegnare',
    SHOW_ALL: 'Tutti',
    SHOW_IN_TRANSIT: 'In transito',
    SHOW_PENDING: 'In sospeso',
    STATE: 'Stato',
    SUCCESS: 'Successo',
    TOTAL_ORDERS: 'Ordini',
    TOTAL_PACKAGES: 'Pacchi',
    TRACKING_NUMBER: 'Numero di tracking',
    TYPE: 'Tipo',
    TYPE_COLLECT: 'Richiesta di ritiro',
    TYPE_DELIVERY: 'Richiesta di consegna',
    USERS: 'Utenti',
    WARNING: 'Attenzione',
    YOUR_ID: 'Il tuo ID: {id}'
  },
  SENTENCES: {
    COLLECT_PACKAGES: 'Scatola(e) dell\'ordine {trackingNumber}.',
    DELIVERED_PACKAGES:
      'Tutti i pacchi dell\'ordine {trackingNumber} sono stati letti.',
    HI: '👋 Ciao, {name},',
    NO_DELIVERIES: 'Non esistono ordini da consegnare.',
    ORDER_TO_RETURN: 'Compila il PIN dell\'ordine da restituire.',
    RECEIVED_PACKAGES: 'Tutti i pacchi sono stati ricevuti.',
    UNDELIVERED_PACKAGES:
      'Ci sono {total} pacchi dell\'ordine {trackingNumber} da leggere.',
    UNRECEIVED_PACKAGES: 'Ci sono {total} pacchi da ricevere.',
    WELCOME: 'Benvenuto. Cosa devi fare?',
    WELCOME_WITH_PROZIS_POINTS: 'Hai già vinto {prozisPoints} ProzisPoints.',
    WITHOUT_SERVICE_POINTS:
      'Non ci sono punti di servizio attribuiti. L\'app si chiuderà.'
  },
  SUCCESS: {
    CODE_READ: 'Codice {code} letto con successo.'
  }
};
